import React from "react";
import './our_team.css';
import fotoa from '../images/team/SWPN1677.JPG'
import fotob from '../images/climb/PAKI9396b.JPG'
import fotoc from '../images/team/DSCN3373a.jpg'
import fotod from '../images/team/fuco.jpg'

const Explore = () => {
  return(
    <div className="bg-white">
      
        <main className="h-100 d-md-inline-block">
          <div className="heroTeam h-100 text-light d-md-inline-block">
            <h1>Our Team</h1>
            <p></p>
            <img src={require('../images/climb/CIMG5159a.JPG')} alt=""/>
          </div>
        </main>

        <div className="text-dark col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-2 m-0 fontResponsive">
          <div className="">
            <h2 className="card-title text-center">The Team</h2>
            <h5 className="card-title text-left">
              We’re passionate about exploring remote places and authentic experiences that respect cultural heritage and try to preserve untouched places.</h5>
          </div>
        </div>
        <div className="card-columns">
            
            <div className="card">
                <img className="card-img-top" src={fotoa} alt=""/>
                <div className="card-body">
                <h5 className="card-title">Carola Perez</h5>
                <p className="card-text">One of the most experienced and versatile climbers of her generation. High level yoga instructor and exceptional mountain chef.</p>
                </div>
            </div>
            
            <div className="card">
                <img className="card-img-top" src={fotod} alt=""/>
                <div className="card-body">
                <h5 className="card-title">Federico Pisani</h5>
                <p className="card-text">Biologist with solid knowledge of Venezuelan biodiversity. Big Wall climber  with 30 years of experience and current trainer for the Venezuelan Team of Sports Climbing.</p>
                <p className="card-text"><small className="text-muted"></small></p>
                </div>
            </div>
            
            <div className="card">
                <img className="card-img-top" src={fotoc} alt=""/>
                <div className="card-body">
                <h5 className="card-title">Daniel Mamopulakos</h5>
                <p className="card-text">When it comes to expeditions on two wheels, Daniel is our expert. Apart from being a great rock climber, he’s a pioneer at opening new long distance routes for bicycles in one of the geologically oldest places on earth, the remote Gran Sabana.</p>
                <p className="card-text"><small className="text-muted"></small></p>
                </div>
            </div>

            <div className="card">
                <img className="card-img-top" src={fotob} alt=""/>
                <div className="card-body">
                <h5 className="card-title">Ricardo Navas</h5>
                <p className="card-text">He's been an active climber for more than 20 years, ranging from sports climbing to big Wall ascents in remote areas.</p>
                <p className="card-text"><small className="text-muted"></small></p>
                </div>
            </div>

        </div>



      
    </div>
  );
};

export default Explore;



// WEBPACK FOOTER //
// ./src/components/our_team.jsx